import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Vineyards
export const getVineyards = async (params = {}) => {
  const response = await axios.get(`${API_URL}/vineyards`, { params });
  return response.data;
};

// Public featured (no auth required)
export const getFeaturedVineyards = async (limit = 3) => {
  const response = await axios.get(`${API_URL}/featured/vineyards`, { params: { limit } });
  return response.data;
};

export const getFeaturedWines = async (limit = 4) => {
  const response = await axios.get(`${API_URL}/featured/wines`, { params: { limit } });
  return response.data;
};

export const getVineyard = async (id) => {
  const response = await axios.get(`${API_URL}/vineyards/${id}`);
  return response.data;
};

export const createVineyard = async (data) => {
  const response = await axios.post(`${API_URL}/vineyards`, data);
  return response.data;
};

export const updateVineyard = async (id, data) => {
  const response = await axios.put(`${API_URL}/vineyards/${id}`, data);
  return response.data;
};

export const deleteVineyard = async (id) => {
  const response = await axios.delete(`${API_URL}/vineyards/${id}`);
  return response.data;
};

// Wines
export const getWines = async (params = {}) => {
  const response = await axios.get(`${API_URL}/wines`, { params });
  return response.data;
};

export const getWine = async (id) => {
  const response = await axios.get(`${API_URL}/wines/${id}`);
  return response.data;
};

export const createWine = async (data) => {
  const response = await axios.post(`${API_URL}/wines`, data);
  return response.data;
};

export const updateWine = async (id, data) => {
  const response = await axios.put(`${API_URL}/wines/${id}`, data);
  return response.data;
};

export const deleteWine = async (id) => {
  const response = await axios.delete(`${API_URL}/wines/${id}`);
  return response.data;
};

// Ratings
export const rateVineyard = async (vineyardId, data) => {
  const response = await axios.post(`${API_URL}/vineyards/${vineyardId}/ratings`, data);
  return response.data;
};

export const getVineyardRatings = async (vineyardId) => {
  const response = await axios.get(`${API_URL}/vineyards/${vineyardId}/ratings`);
  return response.data;
};

export const rateWine = async (wineId, data) => {
  const response = await axios.post(`${API_URL}/wines/${wineId}/ratings`, data);
  return response.data;
};

export const getWineRatings = async (wineId) => {
  const response = await axios.get(`${API_URL}/wines/${wineId}/ratings`);
  return response.data;
};

// Favorites
export const addFavorite = async (itemId, itemType) => {
  const response = await axios.post(`${API_URL}/favorites`, { item_id: itemId, item_type: itemType });
  return response.data;
};

export const removeFavorite = async (itemId) => {
  const response = await axios.delete(`${API_URL}/favorites/${itemId}`);
  return response.data;
};

export const getFavorites = async (itemType = null) => {
  const params = itemType ? { item_type: itemType } : {};
  const response = await axios.get(`${API_URL}/favorites`, { params });
  return response.data;
};

export const checkFavorite = async (itemId) => {
  const response = await axios.get(`${API_URL}/favorites/check/${itemId}`);
  return response.data.is_favorite;
};

// Stats
export const getRegions = async () => {
  const response = await axios.get(`${API_URL}/stats/regions`);
  return response.data.regions;
};

export const getCountries = async () => {
  const response = await axios.get(`${API_URL}/stats/countries`);
  return response.data.countries;
};

export const getGrapeVarieties = async () => {
  const response = await axios.get(`${API_URL}/stats/grape-varieties`);
  return response.data.grape_varieties;
};

export const getOverview = async () => {
  const response = await axios.get(`${API_URL}/stats/overview`);
  return response.data;
};

export const getVineyardsCount = async (params = {}) => {
  const response = await axios.get(`${API_URL}/stats/vineyards-count`, { params });
  return response.data.count;
};

export const getWinesCount = async (params = {}) => {
  const response = await axios.get(`${API_URL}/stats/wines-count`, { params });
  return response.data.count;
};

// Admin
export const adminListUsers = async () => {
  const response = await axios.get(`${API_URL}/admin/users`);
  return response.data;
};

export const adminGetStats = async () => {
  const response = await axios.get(`${API_URL}/admin/stats`);
  return response.data;
};

export const adminToggleAdmin = async (userId, isAdmin) => {
  const response = await axios.patch(`${API_URL}/admin/users/${userId}/admin-flag`, { is_admin: isAdmin });
  return response.data;
};

export const adminDeleteUser = async (userId) => {
  const response = await axios.delete(`${API_URL}/admin/users/${userId}`);
  return response.data;
};

export const adminUpdateUserType = async (userId, userType) => {
  const response = await axios.patch(`${API_URL}/admin/users/${userId}/user-type`, { user_type: userType });
  return response.data;
};

// Admin - approvals
export const adminUpdateUserStatus = async (userId, status) => {
  const response = await axios.patch(`${API_URL}/admin/users/${userId}/status`, { status });
  return response.data;
};

export const adminUpdateVineyardStatus = async (vineyardId, status) => {
  const response = await axios.patch(`${API_URL}/admin/vineyards/${vineyardId}/status`, { status });
  return response.data;
};

export const adminUpdateWineStatus = async (wineId, status) => {
  const response = await axios.patch(`${API_URL}/admin/wines/${wineId}/status`, { status });
  return response.data;
};

export const adminGetPendingUsers = async () => {
  const response = await axios.get(`${API_URL}/admin/pending/users`);
  return response.data;
};

export const adminGetPendingVineyards = async () => {
  const response = await axios.get(`${API_URL}/admin/pending/vineyards`);
  return response.data;
};

export const adminGetPendingWines = async () => {
  const response = await axios.get(`${API_URL}/admin/pending/wines`);
  return response.data;
};

export const adminGetSeedStatus = async () => {
  const response = await axios.get(`${API_URL}/admin/seed/status`);
  return response.data;
};

export const adminForceSeed = async (force = false) => {
  const response = await axios.post(`${API_URL}/admin/seed`, null, { params: { force } });
  return response.data;
};

export const adminRunDrinkSoonDigest = async () => {
  const response = await axios.post(`${API_URL}/admin/run-drink-soon-digest`);
  return response.data;
};

export const adminTestEmail = async (to) => {
  const response = await axios.post(`${API_URL}/admin/test-email`, null, { params: to ? { to } : {} });
  return response.data;
};

// Cellar
export const getCellar = async () => {
  const response = await axios.get(`${API_URL}/cellar`);
  return response.data;
};

export const getCellarStats = async () => {
  const response = await axios.get(`${API_URL}/cellar/stats`);
  return response.data;
};

export const addToCellar = async (data) => {
  const response = await axios.post(`${API_URL}/cellar`, data);
  return response.data;
};

export const updateCellarItem = async (id, data) => {
  const response = await axios.put(`${API_URL}/cellar/${id}`, data);
  return response.data;
};

export const deleteCellarItem = async (id) => {
  const response = await axios.delete(`${API_URL}/cellar/${id}`);
  return response.data;
};

// Upload
export const uploadFile = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await axios.post(`${API_URL}/upload`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data.url;
};

// AI Pairing Suggestions
export const suggestPairings = async (wineData) => {
  const response = await axios.post(`${API_URL}/wines/pairing-suggest`, wineData);
  return response.data.pairings;
};

export const adminToggleVineyardFeatured = async (vineyardId, isFeatured, order = null) => {
  const params = { is_featured: isFeatured };
  if (order !== null) params.order = order;
  const response = await axios.patch(
    `${API_URL}/admin/vineyards/${vineyardId}/featured`,
    null,
    { params }
  );
  return response.data;
};

// Wine Price History
export const getWinePrices = async (wineId) => {
  const response = await axios.get(`${API_URL}/wines/${wineId}/prices`);
  return response.data;
};

export const addWinePrice = async (wineId, data) => {
  const response = await axios.post(`${API_URL}/wines/${wineId}/prices`, data);
  return response.data;
};

export const deleteWinePrice = async (wineId, priceId) => {
  const response = await axios.delete(`${API_URL}/wines/${wineId}/prices/${priceId}`);
  return response.data;
};

export const getMyWinePurchaseHistory = async (wineId) => {
  const response = await axios.get(`${API_URL}/cellar/wine-price-history/${wineId}`);
  return response.data;
};
